import { ISpineOptions, Spine } from '@esotericsoftware/spine-pixi'

export interface SpineRecord {
  name: string
  instance: Spine
  group: string
  createdAt: Date
}

export class SpineManager {
  private map: Map<string, SpineRecord[]> = new Map()

  /**
   * 創建一個新的 Spine 實例並加入管理
   * @param data - Spine 的數據文件
   * @param atlas - Spine 的圖集文件
   * @param name - Spine 的名稱
   * @param group - 所屬的群組，預設為 'Default'
   * @param options - Spine 的選項
   * @returns 創建的 Spine 實例
   */
  public create(data: string, atlas: string, name: string, group = 'Default', skinName?: string, options?: ISpineOptions): Spine {
    const spine = Spine.from(data, atlas, options)
    spine.name = name
    if (skinName) spine.skeleton.setSkinByName(skinName)

    const record: SpineRecord = {
      instance: spine,
      name: name,
      group: group,
      createdAt: new Date(),
    }

    if (!this.map.has(group)) {
      this.map.set(group, [])
    }

    this.map.get(group)?.push(record)
    return spine
  }

  /**
   * 根據 GroupList 銷毀 Spine 實例
   * @param groups - 群組名稱列表
   * @param timeDiff - 時間差，僅銷毀超過此時間的實例
   */
  public destroyByGroupList(groups: string[], timeDiff = 0) {
    groups.forEach((group) => {
      this.destroyByGroup(group, timeDiff)
    })
  }

  /**
   * 銷毀指定群組的 Spine 實例
   * @param group - 群組名稱
   * @param timeDiff - 時間差，僅銷毀超過此時間的實例
   */
  public destroyByGroup(group: string, timeDiff = 0) {
    const records = this.map.get(group)
    if (!records) {
      return
    }

    const now = Date.now()
    this.map.set(
      group,
      records.filter((record) => {
        const age = now - record.createdAt.getTime()
        if (age >= timeDiff) {
          record.instance.destroy()
          return false
        }
        return true
      }),
    )
  }
}

export const spineManager = new SpineManager()
